import React, { useContext, useEffect, useState } from "react";
import { Badge, Tooltip } from "@mui/material";
import AppStateContext from "../../contexts/AppStateContext";
import { CartStatusEnum } from "../../types/CartTypes";
import { apiGetCarts } from "../../util/network/Carts";

/** Shows how many quotes sit in REVIEW; it does not track visits, so the
 *  shared sidebar badge props are accepted but unused. */
type BadgeProps = {
  active?: boolean;
};

const ReviewQuoteBadge: React.FC<BadgeProps> = () => {
  const { token } = useContext(AppStateContext);
  const [numberOfQuotesInReview, setNumberOfQuotesInReview] =
    useState<number>(0);

  const fetchQuotes = (): Promise<void> => {
    if (token) {
      // Only the total is needed. The page is 1-based on the backend, which
      // rejects page 0 with a 422.
      return apiGetCarts(token, 1, 1, "created", "desc", [
        CartStatusEnum.REVIEW,
      ])
        .then((res) => {
          setNumberOfQuotesInReview(res.total);
        })
        .catch((err) => {
          console.error("Error retrieving quotes", err);
        });
    }
    return Promise.resolve();
  };

  useEffect(() => {
    fetchQuotes();
    const intervalId = setInterval(fetchQuotes, 600000);
    return () => clearInterval(intervalId);
  }, [token]);

  return (
    <>
      {numberOfQuotesInReview > 0 && (
        <Tooltip title="state: REVIEW">
          <Badge color={"primary"} badgeContent={numberOfQuotesInReview} />
        </Tooltip>
      )}
    </>
  );
};
export default ReviewQuoteBadge;
